
import React from 'react';
import { UserLinksPanel } from '../controls/Navigation/UserLinksPanel';
import { ArcaComponent } from './ArcaComponent';

export class NoPermission extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    /*eslint-disable */
    render() {
        return (
            <div>
                <h1 className='centerText' id="tabelLabel">Permission denied</h1>
                <p className='centerText'>You do not have the neccessary access to reach this page.</p>

                <UserLinksPanel />
            </div >
        );
    }
}
